import { render } from "./QuestVictory03.vue?vue&type=template&id=b4e6294a"
import script from "./QuestVictory03.vue?vue&type=script&lang=js"
export * from "./QuestVictory03.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questVictories/QuestVictory03.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4e6294a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4e6294a', __exports__)) {
    api.reload('b4e6294a', __exports__)
  }
  
  module.hot.accept("./QuestVictory03.vue?vue&type=template&id=b4e6294a", () => {
    api.rerender('b4e6294a', render)
  })

}


export default __exports__